/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
// Performance logging to ajs server
import { getQueryParameterFromUrl } from "dc-preview-utils/src/Utils/UrlUtils";
import { isValidHttpUrl } from "utils/UrlUtils";
import { logInfoToProvider } from "logging/logToServer";

export default function log(data) {
  console.log("Normalized Performance numbers : ", { ...data });
  let perfServiceHost = getQueryParameterFromUrl(window.location.href, "perfServiceHost");
  perfServiceHost = decodeURIComponent(perfServiceHost);
  let isPerfAutomation = getQueryParameterFromUrl(window.location.href, "isPerfAutomation");

  // Adding in-house perf automation info for Splunk logging
  if (isPerfAutomation === "true") {
    const splunkLoggingData = { ...data };
    let sessionId = getQueryParameterFromUrl(window.location.href, "sessionId");
    let build = getQueryParameterFromUrl(window.location.href, "build");
    let env = getQueryParameterFromUrl(window.location.href, "env");
    let jenkinsJobId = getQueryParameterFromUrl(window.location.href, "jenkinsJobId");
    let runType = getQueryParameterFromUrl(window.location.href, "runType");
    let wasmSize = getQueryParameterFromUrl(window.location.href, "wasmSize");
    let totalFiles = getQueryParameterFromUrl(window.location.href, "totalFiles");
    splunkLoggingData.perfAutomationSessionId = sessionId;
    splunkLoggingData.build = build;
    splunkLoggingData.env = env;
    splunkLoggingData.jenkinsJobId = jenkinsJobId;
    splunkLoggingData.runType = runType;
    splunkLoggingData.wasmSize = wasmSize;
    splunkLoggingData.totalFiles = totalFiles;

    delete splunkLoggingData.uaDetails;

    console.log("Normalized Automation Performance numbers : ", { ...splunkLoggingData });
    logInfoToProvider("%O", { ...splunkLoggingData });
  }

  if (isValidHttpUrl(perfServiceHost)) {
    return fetch(`${perfServiceHost}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: `data=${JSON.stringify(data)}`
    }).catch(err => {
      console.log("error occured while logging to ajs", err);
    });
  }

  return new Error("Invalid perfServiceHost.");
}
